module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-group', {
    attrs: {
      "label": _vm.label
    }
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    class: {
      'col-sm-10': _vm.deletable, 'col-sm-12': !_vm.deletable
    }
  }, [_c('multiselect', {
    class: {
      'deletable': _vm.deletable
    },
    attrs: {
      "track-by": "id",
      "custom-label": _vm.customLabel,
      "loading": _vm.isLoading,
      "options-limit": 100,
      "searchable": _vm.searchable,
      "internal-search": _vm.internalSearch,
      "options": _vm.store.data,
      "selectLabel": _vm.selectLabel,
      "selectedLabel": _vm.selectedLabel,
      "deselectLabel": _vm.deselectLabel,
      "placeholder": _vm.placeholderLabel,
      "allow-empty": _vm.allowEmpty,
      "reset-after": _vm.resetAfter,
      "hide-selected": _vm.hideSelected
    },
    on: {
      "input": _vm.itemHasChanged,
      "search-change": function (query) { return _vm.getAutocomplete(_vm.request, query); }
    },
    model: {
      value: (_vm.currentSelection),
      callback: function($$v) {
        _vm.currentSelection = $$v
      },
      expression: "currentSelection"
    }
  })], 1), _vm._v(" "), (_vm.deletable) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-button', {
    staticClass: "autocomplete--wipe h-100",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.removeSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1042b914"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Base/BaseAutocomplete.vue
// module id = 1278
// module chunks = 1